/** Animated drop list */
import React, {  useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";

import "./drp-list.css";


export const AnimatedDropList = () => {
    const [active, SetActive] = useState(false);
    const toggleActive = () => SetActive((act) => !act);
    const emptyStr = [];
    //create a 8-d array of empty strings
    for (let k=0; k<8; k++) emptyStr.push('');

    return (
        <div className="list-container">
            <div className={classNames("list-button")} onClick={toggleActive}>
                <span className="button-label">Click to view list</span>
                <button className={classNames("round-anim", {'active': active})}>
                    <FontAwesomeIcon icon={faCaretDown} />
                </button>
            </div>
            <div className={classNames("anim-bg", {'animed': active})}  />
            <div className={classNames("list-box", {'opened': active})}>
                {emptyStr.map((_,k) => {
                    return( 
                    <p className="list-item" key={k}>
                        The quick brown fox jumped over the lazy dog.
                    </p>)
                })}
            </div>
        </div>
    )
}